import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import { UseProductGroup } from "../../basic-information/productGroup/UseProductGroup";
import { useSnackbar } from "notistack";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { rsProgress, rsParentChildsNew } from "../../RecoilStates";
import GroupChilds from "./GroupChilds";
import { useRecoilState } from "recoil";
import CustomPagination from "../../components/CustomPagination";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function GroupSelect(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { enqueueSnackbar } = useSnackbar();
  const { getGroupList } = UseProductGroup();
  const [filtered, setFiltered] = useState([]);
  const [parentID, setParentID] = useRecoilState(rsParentChildsNew);
  const [searchToShow, setSearchToShow] = useState("");
  const [searchState, setSearchState] = useState("");
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    setProgress(true);
    getGroupList(
      searchToShow,
      (productgroups) => {
        setProgress(false);
        setFiltered(productgroups.productGroups);
      },
      false
    );
  }, [searchToShow]);

  const [level4, setLevel4] = React.useState({
    groupID: undefined,
  });

  useEffect(() => {
    if (props.selectedGroupID) {
      setLevel4({ groupID: props.selectedGroupID });
    } else if (!props.selectedGroupID) {
      setLevel4({ groupID: undefined });
      setSearchToShow("");
      setParentID({
        id: undefined,
        name: undefined,
      });
    }
  }, [props.selectedGroupID]);

  function gotStoreId(id, faName) {
    props.setter({
      ...props.lvl1State,
      groupID: id,
    });
    setLevel4({ groupID: id });
    enqueueSnackbar("گروه (( " + [faName] + "  )) با موفقیت  انتخاب شد .", {
      variant: "success",
      autoHideDuration: 3000,
      preventDuplicate: true,
    });
  }

  const columns = [
    {
      field: "id",
      width: 60,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "faName",
      headerName: "نام فارسی",
      width: 250,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "زیرگروه ها",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "زیرگروه ها",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Childs">
            <IconButton
              onClick={() => {
                setParentID({
                  id: cellValues.row.id,
                  name: cellValues.row.faName,
                });
              }}
            >
              <ArrowLeftIcon sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 80,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Button
            fontSize="small"
            color="secondary"
            variant="contained"
            onClick={() => {
              setParentID({
                id: null,
                name: undefined,
              });
              gotStoreId(cellValues.row.id, cellValues.row.faName);
            }}
          >
            انتخاب
          </Button>
        );
      },
    },
  ];

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap={3}
      sx={{ width: "100%", height: "31rem !important", mb: 10 }}
    >
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            placeholder="جستجو گروه"
            size="small"
            sx={{ mb: 2 }}
            variant="outlined"
            value={searchState}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              if (evt.target.value == "") {
                setSearchToShow("");
              }
              setSearchState(evt.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setParentID({
                  id: null,
                  name: "",
                  scrolParent: { top: 0, left: 0 },
                });
                setSearchToShow(searchState);
              }
            }}
          />
          <Box>
            <IconButton
              sx={{ p: 0, m: 1 }}
              onClick={() => {
                setProgress(true);
                getGroupList(
                  searchToShow,
                  (productgroups) => {
                    setProgress(false);
                    setFiltered(productgroups.productGroups);
                  },
                  false
                );
              }}
            >
              <CachedIcon />
            </IconButton>
            <IconButton sx={{ p: 0 }} href="/productgroups" target="_blank">
              <LinkIcon />
            </IconButton>
          </Box>
        </Box>
        <DataGrid
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "&  .MuiDataGrid-columnHeader:focus-within": {
              outline: "none",
            },
            "&  .MuiDataGrid-cell:focus-within ": {
              outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
            },
            "& .muirtl-s1v7zr-MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !Important",
            },
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-virtualScrollerRenderZone": {
              width: "100% !important",
            },
            "& .primary": {
              width: "100%",
              backgroundColor: "#ECF6E7 !important",
            },
            "& .none": {
              width: "100%",
              backgroundColor: "#fff !important",
            },
            "& .secondary": {
              width: "100%",
              backgroundColor: "#e9d8f2 !important",
            },
          }}
          getRowClassName={(params) => {
            if (params.row.id == level4.groupID) {
              return "secondary";
            }
            if (params.row.id == parentID.id) {
              return "primary";
            }
            if (params.row.id !== parentID.id) {
              return "none";
            }
            if (params.row.id == props.product.groupID) {
              return "secondary";
            }
          }}
          columns={columns}
          rows={filtered ? filtered : []}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          hideFooter
        />
      </Box>
      <Box
        sx={{ mt: isSmall && 6 }}
        gridColumn={isSmall ? "span 12" : "span 6"}
      >
        <GroupChilds
          searchToShow={searchToShow}
          setSearchToShow={setSearchToShow}
          parentID={parentID}
          ProductGroup
          groupID={level4.groupID}
          Offer
          setGroupID={gotStoreId}
        />
      </Box>
    </Box>
  );
}
